import * as c from 'common/constants';

/**
 * Filters reducer
 */
const initialFilters = {};

export const filters = (filtersName) => (state = initialFilters, action) => {
  switch (action.type) {
    /**
     * Create filters' set
     *
     * @param {object} filters
     */
    case c.SET_FILTERS: {
      if (filtersName === action.filtersName) {
        return action.filters;
      }

      return state;
    }

    /**
     * Reset filters
     */
    case c.RESET_FILTERS: {
      if (filtersName === action.filtersName) {
        return initialFilters;
      }

      return state;
    }

    default: {
      return state;
    }
  }
};

export default filters;



// WEBPACK FOOTER //
// ./src/common/reducers/filtersReducer.js